import {Card, CardContent, CardHeader} from "@common/components/Card.tsx";

function CompanyAlertsView() {
    return (
        <Card>
            <CardHeader>
                <h2 className="text-xl font-semibold text-foreground">Company Alerts</h2>
            </CardHeader>
            <CardContent>
                <p>Coming soon...</p>
            </CardContent>
        </Card>
    );
}

export default CompanyAlertsView;